import React, { FC, Fragment, useEffect, useState } from 'react'

export interface NoSsrProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType
}
const NoSsr: FC<React.PropsWithChildren<NoSsrProps>> = ({ as: Element = Fragment, children, ...props }) => {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(true)
  }, [])

  return <Element {...props}>{ready && children}</Element>
}

export default NoSsr

export function WithNoSsr<T>(WrappedComponent, noSsrProps: NoSsrProps = {}) {
  return (props: T) => (
    <NoSsr {...noSsrProps}>
      <WrappedComponent {...props} />
    </NoSsr>
  )
}
